import React from 'react';
import { SearchXIcon } from 'lucide-react';
interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}
export function EmptyState({
  title,
  description,
  action,
  icon
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center px-6 py-12 text-center" data-id="element-681" data-mp="1ob5o6pflq8ze">
      <div className="mb-3 grid h-10 w-10 place-items-center rounded-full bg-canvas text-ink-subtle" data-id="element-682" data-mp="1schd0sqniq6j">
        {icon ?? <SearchXIcon className="h-5 w-5" data-id="element-683" data-mp="vmhy8gjwqvfi" />}
      </div>
      <p className="text-sm font-semibold text-ink" data-id="element-684" data-mp="10o7au0ms3h5p">{title}</p>
      {description && <p className="mt-1 max-w-sm text-xs text-ink-muted" data-id="element-685" data-mp="14or3aqwepwli">{description}</p>}
      {action && <div className="mt-4" data-id="element-686" data-mp="19g96zmpteba6">{action}</div>}
    </div>;
}